import {useDispatch, useSelector} from "react-redux";
import {useLazyGetBusinessUnitsQuery, useLazyGetCountriesQuery} from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import { setCountries, setBusinessUnits, filterUnits } from "../../../Store/Slice/registerSlice";
import showToast from "../../Hooks/toast";

const useCountriesApi = () => {
  const dispatch = useDispatch();
  const [getCountries] = useLazyGetCountriesQuery();
  const [getBusinessUnits] = useLazyGetBusinessUnitsQuery();
  const get = () => {
    dispatch(setLoader(true));
    getCountries()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setCountries(res?.data))
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  const fetchBusinessUnits = () => {
    dispatch(setLoader(true));
    getBusinessUnits()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setBusinessUnits(res?.data));
        dispatch(filterUnits(res?.data))
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    get,
    fetchBusinessUnits
  };
};

export default useCountriesApi;
